export const FOOTER_BOTTOM_LINKS = [
  { title: "Terms & Conditions", href: "/terms-of-use/" },
  { title: "Privacy Policy", href: "/privacy-policy/" },
  { title: "Sitemap", href: "/sitemap/" },
  { title: "Accessibility Statement", href: "/accessibility-statement/" },
];
